// src/i18n/en/payments.ts
// «Cobros» (mockup 08) — route /payments, Dirección. Not visible to Reception;
// money totals are always hidden from Reception.
export const payments = {
  name: 'Payments |||| Payments',
  subtitle: 'How much was charged, on which channel and by which payment method',

  tiles: {
    amount: 'Charged',
    reservations: 'Reservations charged',
    pctOfArrivals: '% of arrivals',
    amountDetail: '%{count} reservation charged · %{pct} of arrivals |||| %{count} reservations charged · %{pct} of arrivals',
    amountDetailRoommatik:
      '%{count} reservation charged · %{pct} of reservations with Roommatik activity |||| %{count} reservations charged · %{pct} of reservations with Roommatik activity',
    amountDetailMixed:
      '%{count} reservation charged · %{pct} of arrivals and reservations with activity |||| %{count} reservations charged · %{pct} of arrivals and reservations with activity',
    amountDetailNoPct: '%{count} reservation charged |||| %{count} reservations charged',
    average: 'Average per reservation',
    median: 'Median per reservation',
    selfServiceDetail: 'Of which self-service %{amount} (excluding Air Lobby)',
    refundsDetail: '%{count} refund deducted (%{amount}) |||| %{count} refunds deducted (%{amount})',
    preAuthorizations: 'Pre-authorisations not included: %{count}',
    mixedCurrencies: 'Several currencies: shown separately, never added up',
    notMeasurable: 'No figure: a reservation of the period has a payment without the detail of its transactions.',
  },

  axis: {
    arrival: 'Arrival date',
    payment: 'Payment date',
  },

  byChannel: {
    title: 'By channel',
    columns: { channel: 'Channel', currency: 'Currency', reservations: 'Reservations', amount: 'Charged', pct: '%' },
    noChannel: 'No channel',
  },

  byMethod: {
    title: 'By payment method',
    description: 'Charges by payment method; refunds in their own row, as a negative amount.',
    columns: { method: 'Method', currency: 'Currency', reservations: 'Reservations', amount: 'Amount', failed: 'Failed' },
    methods: {
      cardTerminal: 'Card on terminal',
      cardOnline: 'Card online',
      cash: 'Cash',
      preauthorization: 'Pre-authorisation',
      unknown: 'Not specified',
      refund: 'Refunds',
    },
  },

  byHotel: {
    title: 'By property',
    columns: {
      hotel: 'Property',
      currency: 'Currency',
      arrivals: 'Arrivals',
      reservations: 'Reservations charged',
      pct: '%',
      amount: 'Charged',
      average: 'Average',
      previousAmount: 'Previous period',
    },
  },

  help: {
    title: 'Payments',
    description:
      'Charged = firm charges minus refunds, on every channel (kiosk, phone, online and Air Lobby), without pre-authorisations and per currency: two currencies are never added up. «Self-service» is the part charged without staff (kiosk, phone and online); Air Lobby is operated by hotel staff.',
    features: {
      axis: 'By arrival date: every transaction of the reservations arriving in the period. By payment date: the transactions made in the period, by the hotel day; this axis has no % of arrivals.',
      arrivals:
        "The % of arrivals uses the same arrivals as Summary: those of the hotel's reservation list, without cancelled and no-show, when the hotel shares it; otherwise the reservations with Roommatik activity. It counts the arrivals with a firm charge.",
      methods: '«Failed» counts reservations whose payment ended failed and that have no charge in the selection: a reservation is never both charged and failed.',
    },
    tips: {
      hidden: 'This page is not available to the reception role.',
    },
  },
};

export default payments;
